import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function deleteJobRole(jobId: string, roleId: string) {
  const response = await fetch(`${apiEndpoint}/jobs/${jobId}/roles/${roleId}`, {
    method: 'DELETE',
    headers: await standardHeaders(),
    mode: 'cors',
  });
  if (response.ok) {
    return await response.json();
  }
  throw new Error(response.statusText);
}
